<template lang="pug">
.firstLayer
  img.hand_left(src='../static/kv__hands2.svg')
  img.hand_rigth(src='../static/kv__hands1.svg')
  img.firstLayer_logo.pc(src='../static/KV_v8_sign.svg')
  .firstLayer_logo.mobile
    img(src='../static/KV_v8_sign.svg').landscape
  img.firstLayer__logo.pc(src='../static/KV_v8_neoconf.svg')
  .firstLayer__content
    .firstLayer__text Первая <br> онлайн-конференция
    img.firstLayer__logo.mobile(src='../static/KV_v8_neoconf.svg')
    .firstLayer__date 13 ноября, 19:30
  .firstLayer__button.pc
    <svg width="32" height="48" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.325 0H14.671C6.418 0.615 0 7.065 0 14.815V33.069C0 41.3 7.176 48 16 48C24.824 48 32 41.3 32 33.07V14.814C32 7.07 25.581 0.62 17.325 0ZM29 32.871C29 39.555 23.167 44.99 16 44.99C8.833 44.99 3 39.555 3 32.871V15.106C3 8.423 8.829 2.987 16 2.987C23.171 2.987 29 8.423 29 15.106V32.871ZM16 13.007C15.4737 13.0019 14.9671 13.2065 14.5919 13.5755C14.2167 13.9446 14.0037 14.4477 14 14.974V20.039C14.0706 21.0892 14.943 21.9049 15.9955 21.9049C17.048 21.9049 17.9204 21.0892 17.991 20.039V14.974C17.9827 13.8817 17.0923 13.002 16 13.007Z" fill="white" fill-opacity="0.3"/>
    </svg>
  .firstLayer__button.mobile LIVE-ТРАНСЛЯЦИЯ
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 1.29756L10.6 -6.11959e-08L6 4.26341L1.4 -4.63341e-07L-5.67181e-08 1.29756L6 6.85854L12 1.29756Z" fill="white"/>
    </svg>


</template>

<script>
export default {
  name: 'firstLayer',
};
</script>

<style lang="sass">
.hand
  &_left, &_rigth
    position: absolute
    z-index: 11
    width: 139px
    @media screen and (min-width: 813px)
      width: 42vw
  &_left
    left: 0
    bottom: 1vw
    // top: 0
    // margin: auto
    animation: leftHand 5s infinite alternate
    @media screen and (max-width: 812px)
      left: -38px
      top: 119px
      margin: auto
      bottom: 0
  &_rigth
    right: 0
    // bottom: 0
    top: 2vw
    // margin: auto
    animation: rigthHand 5s infinite alternate
    @media screen and (max-width: 812px)
      margin: auto
      top: 58px
      bottom: 0
      right: -28px
  @keyframes rigthHand
    0%
      -webkit-transform: translateX(0%)
    100%
      -webkit-transform: translateX(10%)

  @keyframes leftHand
    0%
      -webkit-transform: translateX(0%)
    100%
      -webkit-transform: translateX(-10%)
.firstLayer
  height: 100vh
  background: url('../assets/back.png')
  background-repeat: no-repeat
  background-size: cover
  padding: 203px 54px 125px 45px
  background-position: center 28%
  display: flex
  align-items: center
  flex-direction: column
  box-sizing: border-box
  position: relative
  // overflow: hidden
  &::before
    position: absolute
    content: ''
    background: linear-gradient(0deg, #000000 40.2%, rgba(0, 0, 0, 0) 100%)
    bottom: 0
    right: 0
    left: 0
    height: 250px
    @media screen and (orientation: landscape) and (max-width: 812px)
      background: linear-gradient(0deg, #000000 -3.8%, rgba(0, 0, 0, 0) 100%)
      height: 102px
      z-index: 12
  @media screen and (max-width: 812px)
    padding: 65px 20px 24px
    background: #131319

  &_logo
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    margin: auto
    width: 15.5vw
    z-index: 10
    @media screen and (max-width: 812px)
      width: fit-content
      height: fit-content
      top: 32px
      img
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        transform: translate(-50%, -18%);
        width: auto
        position: absolute
        z-index: 5
        width: 125px
      &::before
        z-index: 4
        content: ''
        position: absolute
        background-size: contain
        background-repeat: no-repeat
        background-image: url('../static/back2.png')
        width: 100vw
        height: 185vw
        transform: translate(-50%, -282px)
    @media screen and (orientation: landscape) and (max-width: 812px)
      &::before
        z-index: 4
        content: ''
        position: absolute
        background-size: contain
        background-repeat: no-repeat
        background-image: url('../static/back2.png')
        width: 100vw
        height: 186vw
        transform: translate(-50%, -282px)

  &__content
    display: flex
    flex-direction: column
    align-items: flex-end
    margin-left: auto
    position: relative
    z-index: 10
    margin-top: auto
    @media screen and (max-width: 812px)
      align-items: center
      margin: 0
  &__text
    font-size: 36px
    line-height: 42px
    text-align: right
    color: #FFFFFF
    margin-bottom: 25px
    font-weight: bold
    br
      display: none
    @media screen and (max-width: 812px)
      text-align: center
      font-size: 30px
      line-height: 35px
      margin-bottom: 0px
      br
        display: block
  &__logo
    width: 612px
    height: 207px
    margin-right: auto
    margin-bottom: 24px
    position: relative
    z-index: 12
    max-height: 22vh
    @media screen and (max-width: 812px)
      width: 100%
      height: auto
      margin-bottom: 0
      max-width: 320px
      max-height: none
  &__date
    font-size: 18px
    line-height: 21px
    color: #FFFFFF
  &__button
    position: absolute
    bottom: 60px
    @media screen and (max-width: 812px)
      margin-top: auto
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      font-size: 16px
      line-height: 19px
      letter-spacing: 2px
      color: #FFFFFF
      mix-blend-mode: normal
      opacity: 0.3
      position: relative
      z-index: 11
      svg
        margin-top: 6px
    @media screen and (orientation: landscape) and (max-width: 812px)
      position: absolute;
      bottom: 33px;
</style>
